<script lang="ts" setup>
	withDefaults(
		defineProps<{
			header?: string
			headerClass?: ClassContext
			paragraphClass?: ClassContext
			paragraph?: string
			modalButtonText?: string
			closeOnBg?: boolean
			useCancelBtn?: boolean
			show: boolean
		}>(),
		{
			useCancelBtn: true
		}
	)
	const emit = defineEmits<{
		(param: 'done', arg?: Function): void
		(param: 'update:show', arg: boolean): void
	}>()
</script>

<template>
	<dialogs
		:show="show"
		modal-class="max-w-[600px] sm:min-h-[500px] flex-col items-center justify-center"
		:use-cancel-btn="useCancelBtn"
		@change="e => emit('update:show', e)"
	>
		<div class="flex flex-col items-center justify-center gap-5 gap-y-8 sm:gap-y-16 lg:px-8">
			<slot name="icon">
				<lazy-tools-icon
					dir="fill"
					icon="success-check"
					class="pt-5"
					svg-class="sm:w-[226.009px] sm:h-[154px] w-[150px]"
				/>
			</slot>

			<div class="space-y-5 text-center">
				<h4 class="text-xl font-semibold text-blue-950 md:text-[28px]" :class="headerClass">
					<slot name="header">
						{{ header }}
					</slot>
				</h4>
				<p
					class="max-w-lg text-sm font-medium text-gray-500 md:text-base md:leading-[25.888px]"
					:class="paragraphClass"
				>
					<slot name="paragraph">
						{{ paragraph }}
					</slot>
				</p>
			</div>

			<div class="w-full">
				<slot name="button">
					<button
						type="button"
						class="default-btn w-full justify-center bg-primary-2 text-white"
						@click="emit('done')"
					>
						{{ modalButtonText }}
					</button>
				</slot>
			</div>
		</div>
	</dialogs>
</template>
